(function ($) {
	'use strict';

	$.iframeResizer = {
		init: function() {
			if ($('.frame-type-theme_iframe iframe').length > 0) {
				$('.frame-type-theme_iframe iframe').each(function(){
					if (!$(this).attr('height')) {
						var _origin = true;

						// for ie11 simply use "false"
						if (!URL) {
							_origin = false;
						} else {
							if ($(this).attr('src').indexOf('http') !== -1) {
								_origin = new URL($(this).attr('src')).origin;
							}
						}

						iFrameResize({
							scrolling: true,
							checkOrigin: _origin,
						}, '#'+ $(this).attr('id'));
					}
				});
			}
		},
	}
})(jQuery);
